import React from "react";
import { BsTwitter, BsInstagram, BsLinkedin, BsGithub } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";

const SocialMedia = () => (
  <div className="app__social">
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.linkedin.com/in/youssefbayad/"
    >
      <div>
        <BsLinkedin />
      </div>
    </a>
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://github.com/YoussefBayad?tab=overview&from=2022-12-01&to=2022-12-31"
    >
      <div>
        <BsGithub />
      </div>
    </a>
  </div>
);

export default SocialMedia;
